import { MenuItemCardPlaceholder } from "components/botanic/MenuItemCard";
import Placeholder, { Rect } from "components/Placeholder";

const MenuItemCarouselPlaceholder: React.FC<{ className?: string }> = ({
  className,
}) => (
  <div className={className}>
    <Placeholder width="150" height="24" className="mb-sm">
      <Rect width="100%" height="100%" />
    </Placeholder>
    <Placeholder width="250" height="12" className="mb-xs">
      <Rect width="100%" height="100%" />
    </Placeholder>
    <div className="flex flex-row overflow-x-hidden p-md -mx-md mb-md gap-3">
      {new Array(4).fill(null).map((_, i) => (
        <MenuItemCardPlaceholder
          className="basis-1/4 min-w-[240px] bg-white"
          key={i}
        />
      ))}
    </div>
    <Placeholder width="250" height="20" className="lg:hidden mb-section">
      <Rect width="100%" height="100%" />
    </Placeholder>
  </div>
);

export default MenuItemCarouselPlaceholder;
